import { render, staticRenderFns } from "./ScreenPublishStatus.vue?vue&type=template&id=d05d4dac&scoped=true"
import script from "./ScreenPublishStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScreenPublishStatus.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ScreenPublishStatus.vue?vue&type=style&index=0&id=d05d4dac&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05d4dac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d05d4dac')) {
      api.createRecord('d05d4dac', component.options)
    } else {
      api.reload('d05d4dac', component.options)
    }
    module.hot.accept("./ScreenPublishStatus.vue?vue&type=template&id=d05d4dac&scoped=true", function () {
      api.rerender('d05d4dac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/screen/ScreenPublishStatus.vue"
export default component.exports